export enum CampaignStatus {
  pending = 'pending',
  live = 'live',
  paused = 'paused',
  ended = 'ended',
  outOfBudget = 'outOfBudget',
  archived = 'archived',
  // 'pending'
  // 'rejected'
}
